import { temporarilyNotSupport } from '../../utils'

// 帐号信息
export const pluginLogin = temporarilyNotSupport('pluginLogin')
export const login = temporarilyNotSupport('login')
export const checkSession = temporarilyNotSupport('checkSession')
